import { types } from 'mobx-state-tree';

import ChildFullProduct from './ChildFullProduct';
import ProductMulti from './ProductMulti';

const FullProductMulti = types.compose(
  ProductMulti,
  types
    .model('ProductMulti', {
      children: types.optional(types.array(types.late(ChildFullProduct)), []),
    })
    .actions((self) => {
      return {
        setChildren(children) {
          self.children = children;
        },
      };
    })
    .views((self) => {
      return {
        canUseMatrixLayout() {
          const count = self.getMultiElementProperties().length;
          return count >= 1 && count < 5;
        },
        getMultiElementProperties() {
          return self.properties.filter(
            (property) => property.elements.length > 1
          );
        },
      };
    })
);

export default FullProductMulti;
